import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import CachedIcon from '@mui/icons-material/Cached';

import { useMovie } from "../movie/MovieProvider";
import { useMovieSetter } from "../movie/MovieProvider";

import J2VPlayer from './J2VPlayer';

export default function VESceneVisualPreview(props) {

    const movie = useMovie();
    const setMovie = useMovieSetter();

    const test = movie.selected;
    const json = JSON.parse(JSON.stringify(movie.movieObject, null, 2));

    const [reload, setReload] = React.useState(false);
    const [selectedElement, setSelectedElement] = React.useState(null);

    const playerMaxWidth = props.screenWidth / 2 - 50;
    const playerMaxHeight = playerMaxWidth * 9 / 16 * 1.25;

    React.useEffect(() => {
        if (movie.selected && movie.selected.type === "element") {
            // if there is an element selected
            setSelectedElement(movie.selected.itemId);
        }
        else setSelectedElement(null);
        
    }, [movie.selected]);

    return (
        <>
            <Box className="relative mx-3 h-10 bg-white flex justify-start items-center">
                <Box onClick={myTest}>
                    ⚠️ <span className="text-sm">Preview is in BETA</span>
                </Box>
                <Box className="absolute right-0">
                    <span className="mr-2"><span className="text-sm">Reload when needed</span> 👉</span>
                    <Button onClick={handleReload} startIcon={<CachedIcon />}>Reload</Button>
                </Box>
            </Box>
            <Box className="bg-gray-200 flex-grow overflow-y-auto p-3">
                {
                    (!reload) &&
                    <J2VPlayer 
                        movie={json}
                        selectedElement={selectedElement}
                        changeSelectedElement={changeSelectedElement}
                        moveSelectedElement={moveSelectedElement}
                        resizeSelectedElement={resizeSelectedElement}
                        maxWidth={playerMaxWidth} maxHeight={playerMaxHeight} />
                }
            </Box>
        </>

    );

    function myTest() {
        console.log("myTest");
        console.log("Selected element:", selectedElement);
        console.log("test: ", test);
        console.log("movie: ", movie.selected);
    }

    function handleReload() {
        // console.log("Reload");
        setReload(true);
        setTimeout(()=>setReload(false), 500);
    }

    function changeSelectedElement(elementId) {
        // change the selected element provided by the J2VPlayer
        
        setMovie({
            type: "selectItemById",
            itemId: elementId
        });
    }

    function moveSelectedElement(data) {
        // move the selected element with data provided by the J2VPlayer

        console.log("moveSelectedElement():", data);

        setMovie({
            type: "updateProperties",
            itemId: data.element,
            properties: {
                x: Math.floor(data.x),
                y: Math.floor(data.y)
            }
        });
    }

    function resizeSelectedElement(data) {

        console.log("resizeSelectedElement():", data);

        if (["text", "component", "html", "audiogram", "image", "video"].includes(data.type)) {
            console.log("width/height");
            setMovie({
                type: "updateProperties",
                itemId: data.element,
                properties: {
                    x: Math.floor(data.x),
                    y: Math.floor(data.y),
                    width: Math.floor(data.width),
                    height: Math.floor(data.height)
                }
            });
        }
        // else if (["image", "video"].includes(data.type)) {
        //     console.log("scale");
        //     setMovie({
        //         type: "updateProperties",
        //         itemId: data.element,
        //         properties: {
        //             x: Math.floor(data.x),
        //             y: Math.floor(data.y),
        //             scale: {
        //                 width: Math.floor(data.width),
        //                 height: Math.floor(data.height)
        //             }
        //         }
        //     });
        // }
    }
}